import { WeatherSettingsChangeSource } from '@fe/weather';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Checkbox } from '@progress/kendo-react-inputs';
import { SliderWithTooltip } from '../../../../app/components/inputs/SliderWithTooltip';
import { MinimumAshCloudConcentrationOptions, MinimumContrailsLevelOptions, MinimumThunderStormLevelOptions } from '../settings-options';
import { useBooleanSetting, useDropdownSetting, useSliderSetting } from './hooks/useSetting';

export default function MiscSettings() {
    const minimumContrails = useDropdownSetting(
        MinimumContrailsLevelOptions,
        'misc',
        'minimumContrailsLevel',
        WeatherSettingsChangeSource.contrails
    );
    const useTransparency = useBooleanSetting('misc', 'enablePolygonTransparency', WeatherSettingsChangeSource.polygonTransparency);
    const transparencyValue = useSliderSetting('misc', 'polygonTransparency', WeatherSettingsChangeSource.polygonTransparency);

    const minThunderStormLevel = useDropdownSetting(
        MinimumThunderStormLevelOptions,
        'misc',
        'enhancedThunderStormMinLevel',
        WeatherSettingsChangeSource.enhancedThunderStormMinLevel
    );
    const minimumAshCloudConcentration = useDropdownSetting(
        MinimumAshCloudConcentrationOptions,
        'misc',
        'minimumAshCloudConcentration',
        WeatherSettingsChangeSource.minimumAshCloudConcentration
    );

    return (
        <div className="d-flex gap-2 flex-column">
            <div>
                <div>Minimum contrails level:</div>
                <DropDownList {...minimumContrails} />
            </div>

            <div className="d-flex gap-2 align-items-center">
                <Checkbox {...useTransparency} label={'Enable polygon transparency'} />
                <SliderWithTooltip min={0} max={100} {...transparencyValue} className="flex-grow-1" />
            </div>

            <div>
                <div>Minimum TStorm level to display:</div>
                <DropDownList {...minThunderStormLevel} />
            </div>

            <div>
                <div>Minimum ash cloud concentration to display:</div>
                <DropDownList {...minimumAshCloudConcentration} />
            </div>
        </div>
    );
}
